import { render, staticRenderFns } from "./LoginVelaeasy.vue?vue&type=template&id=67abbf4a"
import script from "./LoginVelaeasy.vue?vue&type=script&lang=js"
export * from "./LoginVelaeasy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports